import { Box, useTheme } from "@mui/material";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import handUp3d from "../../../../../../media/images/icons/handUp3d.png";

interface Props {
  title: string;
  icon: string;
  path: string;
  position: "left" | "right" | "center";
}

export default function DashboardMenuItem({
  path,
  title,
  icon,
  position,
}: Props) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.30)",
        position: "relative",
        flex: "1",
        height: "120px",
        border: "1px solid gary",
        backgroundColor:
          position === "right" ? theme.palette.primary.main : "#fff",
        backgroundImage: `
         url(${icon})
         `,
        backgroundRepeat: "no-repeat",
        backgroundSize: "80px",
        backgroundPosition: "50% 30%",
        borderRadius: "16px",
      }}
    >
      {/* <img width={30} src={handUp3d} alt="" /> */}
      <Link
        to={path}
        style={{
          paddingTop: "8px",
          paddingBottom: "8px",
          borderRadius: "12px",
          position: "absolute",
          bottom: "4px",
          textAlign: "center",
          color: position === "right" ? theme.palette.primary.main : "#fff",
          left: "4px",
          right: "4px",
          whiteSpace: "nowrap",
          backgroundColor:
            position !== "right" ? theme.palette.primary.main : "#fff",
        }}
      >
        {title}
      </Link>
    </Box>
  );
}
